import { useClient } from '../supabase/client'
import { useGetJwt } from '../supabase/get-jwt'
import { useRefreshJwt } from '../supabase/refresh-jwt'

import { useMutation, useQueryClient } from '@tanstack/vue-query'
import type { Database, MutationOptions } from '@xleddyl/types'

type Props = Database['dashboard']['Functions']['update_user_locale']['Args']

export const useUpdateUserLocale = (options?: MutationOptions) => {
   const client = useClient()
   const qc = useQueryClient()
   const jwt = useGetJwt()
   const refreshJwt = useRefreshJwt()

   return useMutation({
      onMutate: async () => {
         await qc.getDefaultOptions().mutations?.onMutate?.(options)
      },
      mutationFn: async (props: Props) => {
         if (jwt.value?.user_details) {
            await client.schema('dashboard').rpc('update_user_locale', props).throwOnError()
         }

         await refreshJwt.mutateAsync()
      },
   })
}
